export const NAV_LOGOUT = 'assets/icons/logout.svg'
export const NAV_HOME = 'assets/icons/home.svg'
export const DASHBOARD = 'assets/icons/dashboard.png'
export const SERVICES = 'assets/icons/services.png'
export const OPERATORS = 'assets/icons/operators.png'
export const CURRENCIES = 'assets/icons/currencies.png'
export const FULLSCREEN = 'assets/icons/full-screen.png'
export const CASES = 'assets/icons/cases.png'
export const LOGOUT = 'assets/icons/logout.png'
export const START = 'assets/icons/start.png'
export const PLUS = 'assets/icons/plus.png'
export const PAUSE = 'assets/icons/pause.png'
export const CLONE = 'assets/icons/clone.png'
export const COUNTRIES = 'assets/icons/countries.png'
export const PROPERTIES = 'assets/icons/properties.png'
export const NO_PROPERTIES = 'assets/icons/empty-box.png'
